<template>
    <form class="mb-0">
        <div>
            <div class="card acompamento">
                <div class="detalhe-pedido px-0">

                    <div class="col-md-12 text-center card-header py-3 bg-light">

                        <h5 class="mb-0">
                            <strong>Número do Pedido: </strong>
                            <span class="text-primary py-2 px-3 bg-white rounded-pill"> {{ pedido.numeroPedido || pedido.pedidoId }}</span>
                        </h5>
                        
                        <div class="mt-2 text-center" v-if="pedido.ehTroca">
                            <span class="badge badge-warning rounded-pill d-inline-flex align-items-center justify-content-center" style="font-size: 0.9rem; padding: 8px 16px;">Pedido gerado através de uma solicitação de troca</span>
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="" v-bind:class="[possuiProdutoPreVenda ? 'col-md-7' : 'col-12']">
                                <div class="row">

                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-5' : 'col-md-6']">
                                        <label class="" v-if="pedido.cpF_CNPJ.length<=11"><strong>CPF:</strong></label>
                                        <label class="" v-if="pedido.cpF_CNPJ.length>=14"><strong>CNPJ:</strong></label>
                                        <span> {{ pedido.cpF_CNPJ ? pedido.cpF_CNPJ : '--' }}</span>
                                    </div>

                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-7' : 'col-md-6']">
                                        <div v-if="!cnaStore && !pedido.ehTroca">
                                            <label class=""><strong>Situação do pagamento:</strong></label>
                                            <span> {{ (pedido.pedidoPagamento && pedido.pedidoPagamento.statusGateway && pedido.pedidoPagamento.statusGateway.descricao) || '--' }}</span>
                                        </div>
                                    </div>
                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-5' : 'col-md-6']" v-if="!pedido.ehTroca">
                                        <label class=""><strong>Forma de Pagamento:</strong></label>
                                        <span v-if="pedido.pedidoPagamento && pedido.pedidoPagamento.formaPagamento && pedido.pedidoPagamento.formaPagamento.formaPagamentoId != 2 && pedido.pedidoPagamento.formaPagamento.formaPagamentoId != 3"> {{ pedido.pedidoPagamento.formaPagamento.nome || '--'}}</span>
                                        <span v-if="pedido.pedidoPagamento && pedido.pedidoPagamento.formaPagamento && pedido.pedidoPagamento.formaPagamento.formaPagamentoId == 2"> {{ pedido.pedidoPagamento.formaPagamento.nome ? pedido.pedidoPagamento.formaPagamento.nome + ' (em '+pedido.parcelamento+'x)' : '--'}}</span>
                                        <span v-if="pedido.pedidoPagamento && pedido.pedidoPagamento.formaPagamento && pedido.pedidoPagamento.formaPagamento.formaPagamentoId == 3"> {{ pedido.pedidoPagamento.formaPagamento.nome ? pedido.pedidoPagamento.formaPagamento.nome + ' (em '+pedido.parcelamento+'x)' : '--'}}</span>

                                    </div>
                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-7' : 'col-md-6']">
                                        <label class=""><strong>Data do pedido:</strong></label>
                                        <span> {{ pedido.dataCriacao ? pedido.dataCriacao : '--' }}</span>
                                    </div>
                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-5' : 'col-md-6']">
                                        <label class=""><strong>Status do Pedido:</strong></label>
                                        <span> {{ pedido.statusPedido ? pedido.statusPedido.nome : '--' }}</span>
                                    </div>

                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-7' : 'col-md-6']" v-if="!pedido.ehTroca">
                                        <h5>
                                            <label class=""><strong>Valor:</strong></label>
                                            {{ formatPrice(pedido.valorLiquido) }}
                                            <template v-if="pedido.taxa > 0">
                                                <br />
                                                <small style="color:red">+ taxas aplicadas pelo gateway {{ formatPrice(pedido.taxa) }}</small>
                                            </template>
                                        </h5>
                                    </div>
                                </div>
                                </div>
                                
                            

                            <div class="status-entrega" v-bind:class="[possuiProdutoPreVenda ? 'col-md-5' : 'col-md-12']">
                                <hr class="my-2" v-if="!possuiProdutoPreVenda" />
                                <label class="pb-2"><strong>{{(possuiProdutoPreVenda ? '' : 'Status da Entrega:')}}</strong></label>
                                <div class="steps text-center" :style="{ 'margin-left': possuiProdutoPreVenda ? '0px' : '120px' }">
                                    <div class="row">
                                        <div class="" v-bind:class="[possuiProdutoPreVenda ? 'col-md-6' : 'col-2 w-20']"><span>Pedido Efetuado</span></div>
                                        <div class="" v-if="!cnaStore" v-bind:class="[possuiProdutoPreVenda ? 'col-md-6' : 'col-2 w-20']"><span>Pagamento Confirmado</span></div>
                                        <!--<div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao"><span>Em Separação</span></div>-->
                                        <div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao && !possuiProdutoPreVenda"><span>Emissão Nota NFe/ Preparando Envio</span></div>
                                        <div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao && !possuiProdutoPreVenda"><span>Pedido em Transporte</span></div>
                                    </div>
                                    <div class="row">
                                        <div class="" v-bind:class="[possuiProdutoPreVenda ? 'col-md-6' : 'col-2 w-20']">
                                            <div class="rounded-circle ico-status-entrega" v-bind:class="[pedido.cancelado ? 'bg-danger' : 'bg-success' ]">
                                                <i class="fas fa-user-clock"></i>
                                            </div>
                                            <span>{{pedido.dataStatusPedido}}</span>
                                        </div>
                                        <div class="" v-if="!cnaStore" v-bind:class="[possuiProdutoPreVenda ? 'col-md-6' : 'col-2 w-20']">
                                            <div class="rounded-circle ico-status-entrega" v-bind:class="[pedido.cancelado ? 'bg-danger' : pedido.pagamentoAprovado ? 'bg-success' : 'bg-default']">
                                                <i class="fas fa-thumbs-up"></i>
                                            </div>
                                            <span>{{pedido.pagamentoAprovado ? (pedido.pedidoPagamento && pedido.pedidoPagamento.dataStatusGateway) :  ''}}</span>
                                        </div>
                                        <!--<div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao">
                                            <div class="rounded-circle ico-status-entrega" v-bind:class="[ pedido.cancelado ? 'bg-danger' : pedido.emSeparacao ? 'bg-success' : 'bg-default']">
                                                <i class="fas fa-dolly"></i>
                                            </div>
                                            <span>{{ produtoEmSeparacao }}</span>
                                        </div>-->
                                        <div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao && !possuiProdutoPreVenda">
                                            <div class="rounded-circle ico-status-entrega" v-bind:class="[ pedido.cancelado  ? 'bg-danger' : pedido.pedidoEnviado ? 'bg-success' : 'bg-default']">
                                                <i class="fas fa-people-carry"></i>
                                            </div>
                                            <span>{{ produtoEnviado }}</span>
                                        </div>                                                            
                                        <div class="col-2 w-20" v-if="!pedido.produtoTipoCertificacao && !possuiProdutoPreVenda">
                                            <div class="rounded-circle ico-status-entrega" v-bind:class="[ pedido.cancelado ? 'bg-danger' : pedido.recebido ? 'bg-success' : 'bg-default']">
                                                <i class="fas fa-truck-loading"></i>
                                            </div>
                                            <span>{{ produtoRecebido }}</span>
                                        </div>
                                    </div>



                                    <div class="status-entrega-mobile">
                                        <template v-if="pedido.cancelado == false">
                                            <label class="text-success" v-if="pedido.pagamentoAprovado == false"><strong>Aguardando Pagamento</strong></label>
                                            <label class="text-success" v-if="pedido.pagamentoAprovado"><strong>Pagamento Efetuado</strong></label>
                                            <!--<label class="text-success" v-if="pedido.emSeparacao"><strong>Em separação</strong></label>-->
                                            <label class="text-success" v-if="pedido.pedidoEnviado"><strong>A caminho (escola)</strong></label>
                                            <label class="text-success" v-if="pedido.recebido"><strong>Recebido</strong></label>
                                        </template>
                                        <template v-else>
                                            <label class="text-danger" v-if="pedido.cancelado"><strong>Cancelado</strong></label>
                                        </template>
                                    </div>
                                </div>
                                <div class="row text-center" v-if="pedido.cancelado">
                                    <div class="text-danger p-3 w-100">
                                        <span class="font-weight-bold" v-if="pedido.collectionPedidoLog.length <= 0">
                                            Observação: PEDIDO CANCELADO
                                        </span>
                                        <span class="font-weight-bold" v-else>
                                            Observação: <span v-for="item in pedido.collectionPedidoLog.filter(_ => _.statusPedidoId == 7)">{{ item.descricao + ' ' }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <hr />
                                <a :href="pedido.pedidoPagamento && pedido.pedidoPagamento.urlPagamento" class="btn btn-raised btn-success mr-2" target="_blank" v-if="!pedido.ehTroca && pedido.pedidoPagamento && pedido.pedidoPagamento.urlPagamento && pedido.pedidoPagamento.urlPagamento != '' && pedido.statusPedido && pedido.statusPedido.statusPedidoId != 7 && pedido.pedidoPagamento.formaPagamento && pedido.pedidoPagamento.formaPagamento.formaPagamentoId != 7">
                                    <i class="fas fa-file-invoice"></i> Imprimir boleto
                                </a>
                                <button type="button" class="btn btn-raised btn-outline-success mr-2" @click="onCopiarLinhaDigitavel(pedido)"
                                        v-if="!pedido.ehTroca && pedido.pedidoPagamento && pedido.pedidoPagamento.linhaDigitavel && pedido.statusPedido && pedido.statusPedido.statusPedidoId != 7">
                                    <i class="fas fa-copy"></i> Copiar linha digitável
                                </button>
                                <router-link :to="{ name: 'imprimepedidopix', params: { filter: {pedidoId: pedido.pedidoId }}}" class="btn btn-raised btn-success mr-2" v-if="!pedido.ehTroca && pedido.pedidoPagamento && pedido.pedidoPagamento.formaPagamento && pedido.pedidoPagamento.formaPagamento.formaPagamentoId == 7 && pedido.statusPedido && pedido.statusPedido.statusPedidoId == 1">
                                    <i class="fas fa-file-invoice"></i> Imprimir Dados Pagamento Pix
                                </router-link>
                                <!--<a :href="./imprimepedidopix?pedidoId = {{pedido.pedidoId}}"></a>-->
                                <button v-if="!pedido.ehTroca && pedido.statusPedido && pedido.statusPedido.statusPedidoId == 1 && !cnaStore" type="button" class="btn btn-raised btn-danger mr-3" @click="dialogCancelarPedido = true;">
                                    <i class="fa fa-times"></i> Cancelar Pedido
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="acompamento card" v-for="item in pedido.collectionPessoaProduto">
                <div class="detalhe-produto">
                    <div class="col-md-12 card-header">
                        <h5 class="mb-0">
                            <strong>Produto:</strong><span> {{ item.produto.nome }}</span>
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="media">
                            <div class="position-relative">
                                <img :src="item.produto.imagem" class="align-self-center mr-3" />
                                <div v-if="item.preVenda" class="overlay"></div>
                                <div v-if="item.preVenda" class="pre-venda-text pre-venda-text-acompanhamento">
                                    <span>&emsp;PRÉ-VENDA&emsp;</span>
                                </div>
                                <div class="pedido-header-acompanhamento" v-if="!pedido.ehTroca">
                                    <span class="badge badge-pill badge-cna py-2 px-3 shadow-sm" style=" bottom:0 ">{{ item.valor ? formatPrice(item.valor - item.valorDesconto) : '--' }}</span>
                                </div>
                            </div>
                            <div class="media-body ml-3">
                                <div class="row">
                                    <div class=" mb-3" :class="[possuiProdutoPreVenda ? 'col-md-12 col-lg-4' : 'col-md-4 col-lg-6']">
                                        <h6 class="my-0"><strong>Descrição:</strong></h6>
                                        <span> {{ item.produto.descricao }}</span>
                                        <h6 class="mt-1 mb-0"><strong>Nome do Aluno:</strong></h6>
                                        <span> {{ item.nomeDestinatario }}</span>
                                        <h6 class="mt-1 mb-0" v-if="!pedido.ehTroca"><strong>Valor unitario:</strong></h6>
                                        <span v-if="!pedido.ehTroca"> {{ item.valor ? formatPrice(item.valor - item.valorDesconto) : '--' }}</span>
                                        <div class="mt-4" v-if="item.pessoaProdutoTotvs != null && item.pessoaProdutoTotvs.urlNotaFiscal != ''">
                                            <a :href="item.pessoaProdutoTotvs.urlNotaFiscal" v-bind:class="[item.pessoaProdutoTotvs.xmlNotaFiscal == null || item.pessoaProdutoTotvs.xmlNotaFiscal == '' ? 'disabled' : '']" class="btn btn-raised btn-success" target="_blank">
                                                <i class="fas fa-file-download"></i> Baixar Nota Fiscal
                                            </a>
                                            <i class="ml-2 fas fa-question-circle" v-if="item.pessoaProdutoTotvs.xmlNotaFiscal == null || item.pessoaProdutoTotvs.xmlNotaFiscal == ''" title="Nota em Processamento"></i>
                                        </div>
                                    </div>
                                    <div class="" :class="[possuiProdutoPreVenda ? 'col-md-12 col-lg-2' : 'col-md-4 col-lg-6']">
                                        <h6 class="my-0"><strong>Tipo do Produto:</strong></h6>
                                        <span> {{ item.produto.tipoProduto ? item.produto.tipoProduto.nome : '--' }}</span>
                                        <h6 class="mt-1 mb-0"><strong>Quantidade:</strong></h6>
                                        <span> {{ item.quantidade }}</span>

                                        <h6 class="mt-1 mb-0" v-if="!pedido.ehTroca"><strong>Valor total:</strong></h6>
                                        <span class="valor-total" v-if="!pedido.ehTroca"><strong> {{ item.valorLiquido ? formatPrice(item.valorLiquido) : '--' }}</strong></span>
                                        <!--<h6 class="mt-1 mb-0"><strong>Data início da aula/Data da prova:</strong></h6>
                                        <span> {{ item.dataAulaInicio ? item.dataAulaInicio : '--' }}</span>-->

                                    </div>
                                    <div v-if="possuiProdutoPreVenda" class="col-md-12 col-lg-6">
                                        <div class="steps text-center">
                                            <div class="row">
                                                <div class="col-6"><span>Emissão Nota NFe/ Preparando Envio</span></div>
                                                <div class="col-6"><span>Pedido em Transporte</span></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="rounded-circle ico-status-entrega" v-bind:class="[ pedido.cancelado  ? 'bg-danger' : processaProdutoEnviadoPreVenda(item) ? 'bg-success' : 'bg-default']">
                                                        <i class="fas fa-people-carry"></i>
                                                    </div>
                                                    <span>{{ processaProdutoEnviadoPreVenda(item) ? processaProdutoEnviadoPreVenda(item) : '' }}</span>
                                                    <span v-if="item.preVenda && !processaProdutoEnviadoPreVenda(item)" >Pré-Venda</span>
                                                </div>
                                                <div class="col-6 ">
                                                    <div class="rounded-circle ico-status-entrega" v-bind:class="[ pedido.cancelado ? 'bg-danger' : processaProdutoEntreguePreVenda(item) ? 'bg-success' : 'bg-default']">
                                                        <i class="fas fa-truck-loading"></i>
                                                    </div>
                                                    <span>{{ processaProdutoEntreguePreVenda(item) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <b-card class="acompamento">
                <div class="endereco-pedido px-2">
                    <div class="row ">
                        <div class="col-md-12">
                            <h5 class="mb-0"><strong>Endereço:</strong></h5>

                            <hr />
                        </div>
                        <div class="col-md-12">
                            <label><strong>CEP:</strong></label>
                            <span> {{ pedido.pedidoEndereco.cep ? pedido.pedidoEndereco.cep : '--' }}</span>
                        </div>
                        <div class="col-md-6">
                            <label><strong>Rua:</strong></label>
                            <span> {{ pedido.pedidoEndereco.logradouro ? pedido.pedidoEndereco.logradouro : '--' }}</span>

                        </div>
                        <div class="col-md-6">
                            <label><strong>Número:</strong></label>
                            <span> {{ pedido.pedidoEndereco.numero ? pedido.pedidoEndereco.numero : '--' }}</span>
                        </div>
                        <div class="col-md-6">
                            <label><strong>Complemento:</strong></label>
                            <span> {{ pedido.pedidoEndereco.complemento ? pedido.pedidoEndereco.complemento : '--' }}</span>
                        </div>
                        <div class="col-md-6">
                            <label><strong>Bairro:</strong></label>
                            <span> {{ pedido.pedidoEndereco.bairro ? pedido.pedidoEndereco.bairro : '--' }}</span>
                        </div>
                        <div class="col-md-6">
                            <label><strong>Cidade:</strong></label>
                            <span> {{ pedido.pedidoEndereco.cidade ? pedido.pedidoEndereco.cidade : '--' }}</span>
                        </div>
                        <div class="col-md-6">
                            <label><strong>Estado:</strong></label>
                            <span> {{ pedido.pedidoEndereco.estado ? pedido.pedidoEndereco.estado : '--' }}</span>
                        </div>
                    </div>
                </div>


            </b-card>
        </div>
        <br />
        <button class="float-right btn btn-raised btn-danger" @click="onBack()">Fechar</button>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCancelarPedido" :hide-footer="true" title="Confirmar cancelamento do pedido">
            <form>
                <div class="row">
                    <div class="form-group col-md-12">
                        <div class="col-xs-9">
                            <span class="font-weight-bold">
                                <p>Deseja confirmar o cancelamento deste pedido?</p>
                            </span>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-success float-right" title="Confirmar Pedido" @click="confirmarCancelamentoPedidoManualmente(pedido)">
                    <span> Sim</span>
                </button>
                <button type="button" class="btn btn-outline-danger float-right mr-2" title="Cancelar" @click="hideAll()">
                    <span> Não</span>
                </button>
            </form>
        </b-modal>
    </form>
</template>
<script>
    import { Api } from '@/common/api'
    import base from '@/common/base'
    import auth from "@/common/auth"
    import Cache from "@/common/cache"

    export default {
        name: 'acompanhamento',
        components: {},
        mixins: [base],
        props: { pedido: Object },
        data() {
            return {
                dialogCancelarPedido: false,
                model: { statusPedidoId: '' },
                cnaStore: false,
            }
        },
        methods: {
            confirmarCancelamentoPedidoManualmente(pedido) {
                this.showLoading();
                pedido.attributeBehavior = 'CancelarPagamentoPedidoManualmenteUsuario'
                new Api("pedido").put(pedido).then(() => {
                    this.hideLoading();
                    this.hideAll();
                    this.defaultSuccessResult("Pedido cancelado com sucesso!");
                    window.location = "/home"
                }, err => {
                    this.defaultErrorResult(err);
                });
            },
            gerarPDF: function () {

                new Api("pdf/generate").get({}).then(data => {

                }, err => {
                    this.defaultErrorResult(err);
                })

                // Aqui você deve adicionar a lógica para fazer a chamada à API do .NET Core para gerar o PDF
                // Usando axios ou outra biblioteca para fazer requisições HTTP

                // Exemplo usando axios:
                //axios.get('/api/pdf/generate', { responseType: 'blob' })
                //    .then(response => {
                //        const blob = new Blob([response.data], { type: 'application/pdf' });
                //        const url = window.URL.createObjectURL(blob);
                //        const a = document.createElement('a');
                //        a.href = url;
                //        a.download = 'example.pdf';
                //        document.body.appendChild(a);
                //        a.click();
                //        window.URL.revokeObjectURL(url);
                //    })
                //    .catch(error => {
                //        console.error('Erro ao gerar o PDF:', error);
                //    });
            },

            hideAll() {
                this.dialogCancelarPedido = false;
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return 'R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            onBack: function () {
                this.$emit('on-back')
            },

            processaProdutoEnviadoPreVenda: function (pessoaProduto) {
                
                if (!pessoaProduto.preVenda)
                    return this.produtoEmSeparacao;

                if (!pessoaProduto.pessoaProdutoTotvs) return null;
                if (!pessoaProduto.pessoaProdutoTotvs.romaneio) return null;
                if (!pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog) return null;

                return pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog.find(_ => _.statusRomaneioId == 1) ?
                        pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog.find(_ => _.statusRomaneioId == 1).data : null

            },
            processaProdutoEntreguePreVenda: function (pessoaProduto) {
                

                if (!pessoaProduto.preVenda)
                    return this.produtoEnviado;

                if (!pessoaProduto.pessoaProdutoTotvs) return null;
                if (!pessoaProduto.pessoaProdutoTotvs.romaneio) return null;
                if (!pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog) return null;

                return pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog.find(_ => _.statusRomaneioId == 2) ?
                        pessoaProduto.pessoaProdutoTotvs.romaneio.collectionRomaneioLog.find(_ => _.statusRomaneioId == 2).data : null
            },
            onCopiarLinhaDigitavel(pedido) { 
                navigator.clipboard.writeText(pedido.pedidoPagamento.linhaDigitavel);
                this.defaultSuccessResult('Linha digitável copiada!');
            }

            
        },
        computed: {
            produtoEmSeparacao: function () {
                return this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 4) ?
                    this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 4).data : ''
            },
            produtoEnviado: function () {
                return this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 5) ?
                    this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 5).data : ''
            },
            produtoRecebido: function () {
                return this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 6) ?
                    this.pedido.collectionPedidoLog.find(_ => _.statusPedidoId == 6).data : ''
            },
            possuiProdutoPreVenda: function () {
                return this.pedido.collectionPessoaProduto.find(_ => _.preVenda == true) ? true : false
            },
        },
        async mounted() {
            this.cnaStore = Cache.get(auth.ehCnaStore_key) == "true" ? true : false;
        },
    };
</script>
<style scoped>
    .texto-status {
        font-size: 12px;
    }

    .valor-total {
        font-size: 26px;
        color: #4caf50;
    }

    .pre-venda-text-acompanhamento {
        top: 44%;
        font-size: 1.1em;
    }
</style>
